import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import { useStore } from "vuex";
import Tile from "@/components/shared/Tile.vue";
import OpalModal from "@/components/shared/OpalModal.vue";
import { Button } from "@/models/modal";
import { ReapplyButtonActions } from "@/config/enums";
import { $api } from "@/services/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationReapply',
  setup(__props) {

const store = useStore();

const applicationId = computed<number>(() => store.state.appData?.application?.id);
const tollFreeNumber = computed<string>(() => store.getters["lenderTollFreeNumber"]);
const redirectUrl = computed<string>(() => store.getters["reapplyRedirectUrl"]);
const slcRedirectUrl = computed<string>(() => store.getters["slcRedirectUrl"]);
const subdomain = computed<string>(() => store.getters["lenderSubdomain"]);

const isSubmitting = ref(false);

let countdownIntervalId: number | undefined;

const modalButtons = (action: ReapplyButtonActions): Button[] => {
  if (action === ReapplyButtonActions.CLOSE) {
    return [
      { 
        title: "Close", 
        classStyle: "btn btn-primary",
        onClick: () => store.dispatch("modal/closeModal") 
      }
    ];
  } 
  else if (action === ReapplyButtonActions.CANCELSLC) {
    return [
      { 
        title: "Cancel", 
        classStyle: "btn-gray", 
        onClick: () => store.dispatch("modal/closeModal") 
      },
      { 
        title: "Take me to my SLC", 
        classStyle: "btn btn-primary",
        onClick: async () => {
          if (isSubmitting.value) {
            return;
          };
          isSubmitting.value = true;

          const url = slcRedirectUrl.value;
          if (!url) {
            console.error("SLC redirect url not configured");
            isSubmitting.value = false; 
            return;
          }
          window.location.href = url;
        }
      }
    ];
  } 
  else if (action === ReapplyButtonActions.CANCELCONTINUE) {
    return [
      { 
        title: "Cancel", 
        classStyle: "btn-gray",
        isCancel: true, 
        onClick: () => store.dispatch("modal/closeModal") 
      },
      { 
        title: "Continue to Apply", 
        classStyle: "btn btn-primary",
        onClick: async () => {
          if (isSubmitting.value) {
            return;
          };
          isSubmitting.value = true;

          try {
            const response = await $api.applications.applicationReapply(
              applicationId.value,
              subdomain.value
            );
            if (response?.redirectUrl) {
              window.location.href = response.redirectUrl;
            } else {
              console.error("No redirect url returned");
            }
          } catch (error) {
            console.error("Reapply failed:", error);
            isSubmitting.value = false; 
          }
        }
      }
    ];
  }
  return [];
};


const resolveMergeFields = (text: string, countdown?: number): string => {
  return text
    .replaceAll("{{CU_TFN}}", tollFreeNumber.value ?? "")
    .replaceAll(
      "{{RedirectUrl}}",
      `<a class='link link-underline'  href="${redirectUrl.value}" target="_blank" rel="noopener noreferrer">${redirectUrl.value}</a>`
    )
    .replaceAll("{{CancelledCountdown}}", countdown?.toString() ?? "");
};

const openReapplyModal = async () => {
  if (!applicationId.value) {
    console.warn("Missing applicationId");
    return;
  }

  if (countdownIntervalId !== undefined) {
    clearInterval(countdownIntervalId);
    countdownIntervalId = undefined;
  }

   const response = await $api.applications.getReapplyResponse(applicationId.value);

  if (!response) {
    console.error("No reapply response returned");
    return;
  }

  let countdown = response.cancelledCountdown;

  store.dispatch("modal/openModal", {
      title: response.title,
      html: resolveMergeFields(response.message, countdown),
      buttons: modalButtons(response.reapplyButtonAction as ReapplyButtonActions),
			buttonsPosition: "center",
      centerButtons: true,
      allowBackgroundScroll: false,
    });

  if (countdown > 0) {
    countdownIntervalId = window.setInterval(() => {
      countdown--;

      if (countdown <= 0) {
        clearInterval(countdownIntervalId);
        countdownIntervalId = undefined;
        store.dispatch("modal/closeModal");
      } else {
        const body = resolveMergeFields(response.message, countdown);
        store.dispatch("modal/setBodyModal", body);
      }
    }, 1000);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tile, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("p", { class: "title text-center" }, "Reapply For a Student Loan")
      ], -1)),
      _createElementVNode("div", { class: "d-flex justify-content-center" }, [
        _createElementVNode("button", {
          onClick: openReapplyModal,
          class: "btn btn-primary"
        }, "Reapply")
      ]),
      _createVNode(OpalModal)
    ]),
    _: 1
  }))
}
}

})